/**
 * PQR Header Services - API service layer for PQR (Procedure Qualification Record) header operations
 * Handles CRUD operations for PQR headers, grid data, and file management
 */
import axios from "axios";
let PQR_API_URL;
let MASTER_API_URL;

// Dynamic API URL configuration based on environment
if (process.env.REACT_APP_NODE_ENV === "local") {
  PQR_API_URL = process.env.REACT_APP_PQR_API_URL;
  MASTER_API_URL = process.env.REACT_APP_MASTER_API_URL;
} else {
  PQR_API_URL = process.env.REACT_APP_API_URL + "pqr";
  MASTER_API_URL = process.env.REACT_APP_API_URL + "masters";
}

/**
 * Get PQR grid header data - ACTIVELY USED
 * Used in components: PQRGroove_Overlay.jsx
 * Purpose: Retrieve PQR header data for grid display with filtering
 * @param {Object} gridParameter - Grid filtering parameters
 * @returns {Object} Filtered PQR header records for grid display
 */
export async function getGridHeaderData(gridParameter) {
  let url = `${PQR_API_URL}/PqrHeaderMast/gridPQR`;

  const response = await axios
    .post(url, gridParameter)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}



export const uploadpqrgridfile = async (uploadData) => {
  let url = `${PQR_API_URL}/PqrHeaderMast/uploadpqrgridfile`;
  const response = await axios
    .post(url, { uploadData })
    .then(resp => resp)
    .catch(error => ({ message: "Unable to update upload data", status: false }));
  return response.data;
};


export const deletePQRFile = async (filepath, filename) => {
  const url = `${MASTER_API_URL}/file/pqr/deletefile`;
  const response = await axios
    .post(url, { filepath, filename })
    .then(resp => resp)
    .catch(error => ({ message: "Unable to delete file", status: false }));
  return response.data;
};




















/**
 * Get PQR by project number - ACTIVELY USED
 * Used in components: 
 *   - Pdf_DownloadPQR.jsx
 *   - PQRGrooveTransaction.jsx
 *   - PQRTubesheetPage1.jsx
 *   - PQR_Page1.jsx
 * Purpose: Retrieve PQR header by project number
 * @param {Object} reqParam - Request parameters with project info
 * @returns {Object} PQR header record for specified project
 */
export const getbyprojectno = async (reqParam) => {
  let url = `${PQR_API_URL}/PqrHeaderMast/getprojectnoPQR`;

  const response = await axios
    .post(url, reqParam)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });

  return response.data;
};

/**
 * Get PQR data for editing - ACTIVELY USED
 * Used in components: PQRTubeSheetTransaction.jsx
 * Purpose: Retrieve PQR data when editing existing records
 * @param {Object} reqData - Request data for PQR retrieval
 * @returns {Object} PQR data formatted for editing
 */
export const getPQRonEdit = async (reqData) => {
  let url = `${PQR_API_URL}/PqrHeaderMast/getPQRonEdit`;

  const response = await axios
    .post(url, reqData)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

/**
 * Add new PQR header record - ACTIVELY USED
 * Used in components: PQR_Validations.js (AddUpdatePQRHeader function)
 * Purpose: Create new PQR header record
 * @param {Object} WPQ_Header_Master - PQR header data to create
 * @returns {Object} Creation response
 */
export const AddNewPQR = async (WPQ_Header_Master) => {
  let url = `${PQR_API_URL}/PqrHeaderMast`;

  const response = await axios
    .post(url, WPQ_Header_Master)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

/**
 * Update existing PQR header record - ACTIVELY USED
 * Used in components: PQR_Validations.js (AddUpdatePQRHeader function)
 * Purpose: Update existing PQR header record
 * @param {Object} PQR_Header_MasterUpdate - Updated PQR header data
 * @returns {Object} Update response
 */
export const UpdatePQRHeader = async (PQR_Header_MasterUpdate) => {
  let url = `${PQR_API_URL}/PqrHeaderMast/UpdatePQRHeader`;

  const response = await axios
    .post(url, PQR_Header_MasterUpdate)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

/**
 * Delete PQR header record - ACTIVELY USED
 * Used in components: PQRGroove_Overlay.jsx
 * Purpose: Delete PQR header and associated records
 * @param {Object} DeleteRow - Record to delete
 * @returns {Object} Deletion response
 */
export async function DeletePQR(DeleteRow) {
  let url = `${PQR_API_URL}/PqrHeaderMast/delete`;

  const resp = await axios
    .post(url, DeleteRow)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.message;
    });









  return resp;
}
